const constantsReducer = (
  state = {
    data: {}
  },
  action: {
    type: "SET_CONSTANTS";
    payload: any;
  }
) => {
  switch (action.type) {
    case "SET_CONSTANTS":
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default constantsReducer;